export const navLinks = [
  { label: '热门话题', href: '#topics' },
  { label: '观众热评', href: '#comments' },
  { label: '追剧快讯', href: '#updates' },
  { label: '平台优势', href: '#features' },
  { label: '焦点专题', href: '#carousel' },
  { label: '移动追剧', href: '#app' },
];

export const heroStats = [
  { label: '热播剧集', value: '3.2万+' },
  { label: '每日更新', value: '200+集' },
  { label: '高清画质', value: '1080P' },
];

export const updatesData = [
  {
    date: '2026-08-01',
    tag: '新剧上线',
    title: '《长安十二时辰》续集今日首播，原班人马回归引期待',
    summary: '备受瞩目的古装悬疑剧续作正式上线，张导再次操刀，延续前作高品质制作水准。',
  },
  {
    date: '2026-07-31',
    tag: '更新公告',
    title: '《追风者》大结局提前释出，全集 40 集一次性更新完毕',
    summary: '应观众强烈要求，平台提前放出谍战剧《追风者》大结局，全集免费观看。',
  },
  {
    date: '2026-07-30',
    tag: '热门推荐',
    title: '暑期档韩剧《无声追踪》第三季上线，首日播放量破千万',
    summary: '犯罪悬疑题材再掀追剧狂潮，平台上线首日即登顶实时热度榜。',
  },
  {
    date: '2026-07-29',
    tag: '专题策划',
    title: '「古装仙侠」专题上线，收录近五年经典仙侠剧全集资源',
    summary: '从《花千骨》到《苍兰诀》，一站式满足仙侠爱好者追剧需求。',
  },
  {
    date: '2026-07-28',
    tag: '技术升级',
    title: '平台播放器全面升级，支持 4K 超清画质与智能加载加速',
    summary: '新版播放器上线，缓冲速度提升 60%，支持多线路自动切换。',
  },
  {
    date: '2026-07-27',
    tag: '新剧上线',
    title: '泰国青春剧《星光恋人》引进上线，双语字幕同步更新',
    summary: '热门泰剧独家上线中文平台，中泰双语字幕助你无障碍追剧。',
  },
  {
    date: '2026-07-26',
    tag: '活动预告',
    title: '「夏日追剧季」即将开启，多部热播剧限时解锁全集免费看',
    summary: '活动期间热门剧集全部免费开放，无广告无中断畅享追剧体验。',
  },
];

export const mediaData = [
  {
    title: '《暗流》',
    category: '悬疑犯罪',
    desc: '一桩离奇命案揭开城市暗面，刑警与心理师联手追凶',
    hotLabel: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Dark%20suspenseful%20crime%20drama%20scene%20with%20mysterious%20urban%20night%20atmosphere%2C%20detective%20silhouette%20under%20streetlight%2C%20cinematic%20lighting%2C%20film%20noir%20aesthetic%2C%20moody%20tones%2C%20professional%20movie%20poster%20style&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '《长安旧梦》',
    category: '古装传奇',
    desc: '大唐盛世下的权谋与情感纠葛，再现盛世风华',
    hotLabel: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20palace%20scene%20with%20traditional%20architecture%2C%20flowing%20silk%20robes%2C%20warm%20golden%20lantern%20light%2C%20historical%20costume%20drama%20aesthetic%2C%20elegant%20composition%2C%20soft%20atmospheric%20lighting&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '《星海迷途》',
    category: '科幻冒险',
    desc: '近未来太空探索遭遇未知文明，人类命运何去何从',
    hotLabel: '新上线',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20exploration%20scene%20with%20distant%20galaxy%20and%20nebula%2C%20spaceship%20silhouette%20against%20cosmic%20backdrop%2C%20deep%20purple%20and%20gold%20color%20palette%2C%20cinematic%20space%20opera%20aesthetic%2C%20dramatic%20composition&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    title: '《夏日奇迹》',
    category: '青春校园',
    desc: '五个少年在海边小镇经历的成长与友情故事',
    hotLabel: '推荐',
    image: 'https://readdy.ai/api/search-image?query=Youth%20drama%20scene%20at%20seaside%20town%20during%20golden%20sunset%2C%20group%20of%20friends%20walking%20on%20beach%2C%20warm%20nostalgic%20atmosphere%2C%20soft%20natural%20lighting%2C%20coming%20of%20age%20aesthetic%2C%20gentle%20waves%20and%20pastel%20sky&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
  {
    title: '《迷雾追踪》',
    category: '悬疑推理',
    desc: '连环案件牵扯二十年旧案，真相远比想象更复杂',
    hotLabel: '高分',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20scene%20with%20foggy%20city%20alley%20at%20night%2C%20investigation%20board%20with%20red%20strings%20and%20photos%2C%20noir%20cinematography%2C%20dramatic%20shadows%2C%20dark%20green%20and%20amber%20tones%2C%20suspenseful%20mood&width=640&height=360&seq=media-card-05&orientation=landscape',
  },
];

export const topicsData = [
  { name: '古装仙侠', count: '128万讨论', hot: true },
  { name: '悬疑推理', count: '96万讨论', hot: true },
  { name: '韩剧热播', count: '85万讨论', hot: true },
  { name: '甜宠恋爱', count: '72万讨论', hot: false },
  { name: '谍战风云', count: '68万讨论', hot: false },
  { name: '科幻未来', count: '55万讨论', hot: false },
  { name: '武侠经典', count: '51万讨论', hot: false },
  { name: '都市情感', count: '47万讨论', hot: false },
  { name: '青春校园', count: '42万讨论', hot: false },
  { name: '家族恩怨', count: '38万讨论', hot: false },
];

export const featuresData = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库 免费观看',
    desc: '收录超过 3 万部电视剧资源，涵盖中韩日泰等多国剧集，全部免费无需会员即可畅享高清追剧体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新 同步追剧',
    desc: '热门剧集第一时间上线，每日更新超过 200 集，多线路智能切换确保播放流畅不卡顿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净 无广告干扰',
    desc: '播放页面干净清爽无弹窗广告，安全链接无恶意跳转，专注为你提供纯粹的追剧环境。',
  },
];

export const cardsData = [
  {
    title: '《山河令》前传',
    category: '武侠古装',
    rating: '9.2',
    desc: '江湖风云再起，少年侠客踏上复仇与救赎之路',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20with%20swordsman%20in%20flowing%20robes%20on%20misty%20mountain%2C%20ancient%20Chinese%20aesthetic%2C%20dramatic%20composition%2C%20golden%20and%20crimson%20tones%2C%20wuxia%20film%20poster%20style&width=600&height=800&seq=card-drama-01&orientation=portrait',
  },
  {
    title: '《都市幻想》',
    category: '奇幻都市',
    rating: '8.8',
    desc: '拥有超能力的普通人如何在都市中守护所爱',
    image: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20drama%20poster%20with%20neon%20cityscape%20at%20night%2C%20mysterious%20figure%20with%20glowing%20hands%2C%20modern%20superhero%20aesthetic%2C%20vibrant%20magenta%20and%20teal%20lighting%2C%20cinematic%20composition&width=600&height=800&seq=card-drama-02&orientation=portrait',
  },
  {
    title: '《江南烟雨》',
    category: '民国情感',
    rating: '9.0',
    desc: '战火纷飞年代里的刻骨铭心爱情与家国情怀',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20republican%20era%20romance%20drama%20poster%20with%20couple%20in%20traditional%20clothing%20under%20umbrella%20in%20rain%2C%20misty%20water%20town%20background%2C%20nostalgic%20sepia%20and%20teal%20tones%2C%20elegant%20vintage%20aesthetic&width=600&height=800&seq=card-drama-03&orientation=portrait',
  },
  {
    title: '《极限营救》',
    category: '动作警匪',
    rating: '8.5',
    desc: '特种部队退役教官卷入惊天阴谋，孤身拯救城市',
    image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20drama%20poster%20with%20tactical%20operative%20in%20urban%20combat%20scene%2C%20explosion%20background%2C%20intense%20expression%2C%20dark%20orange%20and%20steel%20gray%20color%20palette%2C%20hollywood%20blockbuster%20style&width=600&height=800&seq=card-drama-04&orientation=portrait',
  },
  {
    title: '《逆光飞翔》',
    category: '励志成长',
    rating: '9.3',
    desc: '盲人钢琴少年的逐梦之路，感动千万观众的励志故事',
    image: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20poster%20with%20pianist%20silhouette%20against%20spotlight%20on%20dark%20stage%2C%20dust%20particles%20in%20light%20beam%2C%20warm%20golden%20lighting%2C%20emotional%20and%20uplifting%20atmosphere%2C%20elegant%20minimal%20composition&width=600&height=800&seq=card-drama-05&orientation=portrait',
  },
];

export const carouselData = [
  {
    title: '金庸武侠经典回顾',
    subtitle: '重温那些年我们追过的武侠梦',
    desc: '从《射雕英雄传》到《天龙八部》，收录金庸先生全部改编电视剧，高清修复版一次看够。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20martial%20arts%20drama%20scenery%20with%20ancient%20temple%20on%20misty%20mountain%2C%20pine%20trees%2C%20golden%20sunrise%20light%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20epic%20cinematic%20composition%2C%20warm%20atmospheric%20tones&width=1200&height=600&seq=carousel-topic-01&orientation=landscape',
  },
  {
    title: '暑期悬疑剧连播',
    subtitle: '烧脑推理一夏看不停',
    desc: '精选国内外高分悬疑剧集，每部都让你猜不到结局，准备好和千万观众一起推理破案了吗？',
    tag: '暑期特辑',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20drama%20scene%20with%20magnifying%20glass%20on%20old%20wooden%20desk%2C%20scattered%20case%20files%2C%20vintage%20study%20room%2C%20warm%20lamplight%2C%20noir%20detective%20aesthetic%2C%20rich%20brown%20and%20gold%20tones&width=1200&height=600&seq=carousel-topic-02&orientation=landscape',
  },
  {
    title: '韩剧精选剧场',
    subtitle: '现象级韩剧一网打尽',
    desc: '从经典老剧到最新热播，收录口碑最好的韩剧全集资源，中文字幕同步更新。',
    tag: '韩剧专区',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20with%20cherry%20blossom%20tree%20lined%20street%20in%20spring%2C%20couple%20walking%20together%2C%20soft%20pastel%20pink%20and%20white%20palette%2C%20romantic%20cinematic%20aesthetic%2C%20gentle%20natural%20lighting&width=1200&height=600&seq=carousel-topic-03&orientation=landscape',
  },
  {
    title: '国产精品剧推荐',
    subtitle: '口碑炸裂的国产好剧都在这',
    desc: '精心筛选近三年豆瓣 8 分以上国产剧，每一部都值得反复刷，告别剧荒从这里开始。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20with%20city%20skyline%20at%20blue%20hour%2C%20warm%20apartment%20lights%2C%20contemporary%20lifestyle%20aesthetic%2C%20clean%20modern%20composition%2C%20twilight%20sky%20with%20soft%20transition%20tones&width=1200&height=600&seq=carousel-topic-04&orientation=landscape',
  },
  {
    title: '日剧经典合辑',
    subtitle: '治愈系日剧温暖你的每一天',
    desc: '收录《深夜食堂》《Legal High》等经典日剧全集，工作和生活之余的温暖陪伴。',
    tag: '日剧推荐',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20scene%20with%20cozy%20traditional%20izakaya%20interior%2C%20warm%20lantern%20lighting%2C%20wooden%20counter%2C%20steaming%20food%2C%20intimate%20atmosphere%2C%20soft%20golden%20glow%2C%20slice%20of%20life%20aesthetic&width=1200&height=600&seq=carousel-topic-05&orientation=landscape',
  },
  {
    title: '泰剧热播频道',
    subtitle: '高甜泰剧让你心动一夏',
    desc: '近年最火的泰国青春偶像剧合集，颜值在线剧情上头，追一集就停不下来。',
    tag: '热播推荐',
    image: 'https://readdy.ai/api/search-image?query=Thai%20youth%20drama%20scene%20with%20tropical%20beach%20sunset%2C%20palm%20trees%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20summer%20vibe%2C%20turquoise%20ocean%20and%20soft%20pastel%20sky%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-topic-06&orientation=landscape',
  },
];

export const indexData = [
  { title: '国产剧', icon: 'ri-tv-line', count: '8,200+部', desc: '热门国产电视剧' },
  { title: '韩剧', icon: 'ri-global-line', count: '3,500+部', desc: '最新韩剧资源' },
  { title: '日剧', icon: 'ri-earth-line', count: '2,800+部', desc: '经典日剧合集' },
  { title: '泰剧', icon: 'ri-sun-line', count: '1,200+部', desc: '热门泰剧推荐' },
  { title: '美剧', icon: 'ri-flag-line', count: '4,600+部', desc: '高分美剧精选' },
  { title: '古装剧', icon: 'ri-vip-crown-line', count: '3,100+部', desc: '古装仙侠武侠' },
  { title: '悬疑剧', icon: 'ri-search-line', count: '2,400+部', desc: '烧脑推理剧集' },
  { title: '爱情剧', icon: 'ri-heart-line', count: '5,300+部', desc: '甜宠恋爱剧集' },
  { title: '动漫', icon: 'ri-rocket-line', count: '1,800+部', desc: '热门动漫番剧' },
];

export const faqData = [
  {
    q: '亚洲影视网的电视剧真的完全免费吗？',
    a: '是的，亚洲影视网所有电视剧资源均完全免费观看，无需注册会员，无需支付任何费用。我们通过广告合作维持运营，但不会在播放过程中插入任何弹窗广告或强制观看广告。',
  },
  {
    q: '播放卡顿怎么办？可以切换清晰度吗？',
    a: '平台默认提供 1080P 高清画质，同时支持 720P 和 480P 多清晰度切换。如果遇到卡顿，可以尝试切换备用播放线路或降低清晰度。我们持续优化服务器带宽，确保流畅观影体验。',
  },
  {
    q: '电视剧更新频率如何？能看最新的剧集吗？',
    a: '我们团队 7×24 小时监控最新剧集更新，热门电视剧一般在播出后 2-4 小时内完成上线。每日更新量超过 200 集，让你第一时间追到最新剧情。',
  },
  {
    q: '支持哪些设备观看？有手机 APP 吗？',
    a: '亚洲影视网采用响应式设计，完美支持电脑、平板和手机浏览器直接访问。同时提供安卓和 iOS 客户端下载，在应用商店搜索"亚洲影视"即可安装，APP 端同样免费无广告。',
  },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20simple%20casual%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    name: '追剧达人小王',
    time: '2 天前',
    content: '自从发现亚洲影视网，彻底告别了各种会员付费！资源更新速度真的快，《追风者》大结局居然比电视台还早上线，画质也很清晰，强烈推荐给身边所有爱追剧的朋友！',
    likes: 1286,
    drama: '《追风者》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20gentle%20expression%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20minimal%20style%2C%20warm%20tone&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    name: '剧荒拯救者',
    time: '3 天前',
    content: '分类做得特别好！古装剧专区简直就是宝藏，很多老剧的高清修复版都能找到。最近在重温《琅琊榜》，画面修复得比当年首播还清晰，感动到哭。',
    likes: 967,
    drama: '《琅琊榜》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20confident%20expression%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20casual%20style%2C%20friendly%20look&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    name: '悬疑迷小陈',
    time: '5 天前',
    content: '悬疑剧分类太齐全了！日韩泰中四国悬疑剧都有，《暗流》这部新剧剧情紧凑到停不下来，一口气刷了 8 集。而且完全免费，这个平台真的良心。',
    likes: 756,
    drama: '《暗流》',
  },
];

export const rankingData = [
  { rank: 1, title: '《暗流》', category: '悬疑犯罪', heat: '9800万', trend: 'up', change: '+2' },
  { rank: 2, title: '《长安旧梦》', category: '古装传奇', heat: '9200万', trend: 'up', change: '+5' },
  { rank: 3, title: '《追风者》', category: '谍战剧情', heat: '8900万', trend: 'down', change: '-1' },
  { rank: 4, title: '《无声追踪》', category: '犯罪悬疑', heat: '8500万', trend: 'up', change: '+3' },
  { rank: 5, title: '《星海迷途》', category: '科幻冒险', heat: '7800万', trend: 'up', change: '+8' },
  { rank: 6, title: '《夏日奇迹》', category: '青春校园', heat: '7200万', trend: 'new', change: '新上榜' },
];

export const aboutData = {
  title: '亚洲影视网',
  paragraphs: [
    '亚洲影视网成立于 2019 年，是国内领先的免费电视剧在线观看平台。我们致力于为全球华语观众提供最全、最新、最高清的电视剧免费观看服务，无需注册会员、无需付费订阅，让每一位观众都能畅享追剧乐趣。',
    '平台目前已收录超过 3 万部电视剧资源，涵盖国产剧、韩剧、日剧、泰剧、美剧等多个品类，从经典老剧到最新热播一应俱全。我们的内容团队 7×24 小时不间断更新，确保热门剧集在播出后第一时间上线。',
    '亚洲影视网始终坚持"免费、高清、安全"的核心理念，所有视频采用先进的编码技术确保流畅播放，同时严格过滤恶意广告和弹窗，为观众提供纯净的观影环境。未来我们将持续扩充内容库，优化播放体验，让免费追剧变得更加简单美好。',
  ],
};

export const contactData = {
  title: '与我们联系',
  subtitle: '有任何建议、意见或合作意向，欢迎通过以下方式联系我们',
  email: 'contact@asianvod.example.com',
  wechat: 'AsianVideo_Customer',
  qq: '800123456',
};